import { createSelector } from 'reselect';
import { AppState } from '../reducers';
import { AccountingState } from '../reducers/accounting.reducer';

const accountingState = (state: AppState): AccountingState => state.accounting;

export namespace AccountingSelectors {
  export const getProjectType = createSelector(
    [accountingState],
    (state: AccountingState) => state.projectData.projectType,
  );

  export const getSiteData = createSelector(
    [accountingState],
    (state: AccountingState) => state.accountingSite,
  );

  export const getProjectId = createSelector(
    [accountingState],
    (state: AccountingState) => state.projectData.id,
  );

  export const getProjectData = createSelector(
    [accountingState],
    (state: AccountingState) => state.projectData,
  );

  export const getNotesData = createSelector(
    [accountingState],
    (state: AccountingState) => state.notes,
  );

  export const getAccountingBrowseData = createSelector(
    [accountingState],
    (state: AccountingState) => state.accountingBrowseData,
  );

  export const getFinancialTabIsLoading = createSelector(
    [accountingState],
    state => state.financialTab.isLoading,
  );

  export const getFinancialTabIsLoaded = createSelector(
    [accountingState],
    state => state.financialTab.isLoaded,
  );
}
